module.exports = __webpack_public_path__ + "static/media/forgot-password.bc727678.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/forgot-password.png
 ** module id = 1615
 ** module chunks = 0
 **/